import { useRef } from 'react';
import { useQuery } from '@apollo/client';

import { SEARCH_PRODUCTS } from './queries';

import Button from '../../components/Button';
import ProductListItem from '../../components/ProductListItem';
import Box from '../../components/layout/Box';
import EmptySearch from './EmptySearch';

const SearchProducts = ({ searchString }) => {
  const limit = 10;
  const currentPage = useRef(1);

  const sorting = {
    orderBy: 'publicationDate',
    order: 'DESC',
  };

  const { data, loading, fetchMore } = useQuery(SEARCH_PRODUCTS, {
    variables: {
      searchString,
      pagination: {
        offset: 0,
        limit,
      },
      sorting,
    },
  });

  const products = data?.listProducts || [];
  const hasNextPage = products.length % limit === 0 && products.length > 0;

  return (
    <Box className="flex-column flex-grow-1">
      {products.map((product, index) => (
        <Box
          key={`product-${product.id.toString()}`}
          className="mb-3 pb-3 flex-column"
          style={{
            borderBottom: '2px solid #e7e7e7',
          }}
        >
          <ProductListItem
            product={product}
            showBorder={products.length - 1 !== index}
          />
        </Box>
      ))}

      {hasNextPage && (
        <Box className="justify-content-center mt-3">
          <Button
            isLoading={loading}
            onClick={() => {
              const nextPage = currentPage.current + 1;

              fetchMore({
                variables: {
                  pagination: {
                    offset: products.length,
                    limit,
                  },
                  sorting,
                  searchString,
                },
              });

              currentPage.current = nextPage;
            }}
          >
            Visa mer
          </Button>
        </Box>
      )}

      {!loading && products?.length === 0 && <EmptySearch />}
    </Box>
  );
};

export default SearchProducts;
